<template>
  <div class="client__responses" v-if="client">
    <div class="card">
      <BRow>
        <ClientId :client="client" class="d-none d-sm-block"></ClientId>
        <BCol>
          <div class="mt-3">
            <b-nav class="client__responses__tabs mx-2">
              <b-nav-item v-for="tab in selectedTabs" :key="tab" @click="currentTab = tab" class="client__responses__tabs__tab" :class="{ active: currentTab === tab }">
                {{ $t(`clientResponses.tabs.${tab}`) }}
                <span class="badge badge-pill badge-primary ml-1 mb-1">
                  {{ responses(tab).length }}
                </span>
              </b-nav-item>
            </b-nav>
          </div>
          <div class="tab pl-1 pt-2 pb-4 border-top-0">
            <div class="container mb-5" v-for="(response, index) in responses(currentTab)" :key="index">
              <div class="client__responses__left__title">
                <h5 class="mt-4">
                  {{ response['name_(visible)'] }}
                </h5>
              </div>
              <div class="mt-3">
                <div>
                  {{ response['short_response_(visible)'] }}
                  <div v-if="response['long_response_(visible)']">
                    <b-button v-b-toggle="`collapse-${index}`" variant="primary" class="mt-4">
                      <span class="when-open">
                        {{ $t('clientResponses.readLess') }}
                      </span>
                      <span class="when-closed">
                        {{ $t('clientResponses.readMore') }}
                      </span>
                    </b-button>
                    <b-collapse :id="`collapse-${index}`" class="mt-4">
                      {{ response['long_response_(visible)'] }}
                    </b-collapse>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </BCol>
      </BRow>
    </div>
  </div>
</template>

<script>
  import filter from 'lodash/filter'
  import get from 'lodash/get'

  import ClientId from '@/components/ClientId'
  import responses from '@/data/responses.json'

  export default {
    name: 'ClientResponses',
    components: {
      ClientId
    },
    props: {
      client: {
        type: Object
      }
    },
    data () {
      return {
        tabs: ['client', 'bank', 'others'],
        currentTab: 'client'
      }
    },
    computed: {
      selectedTabs () {
        return filter(this.tabs, tab => this.responses(tab).length)
      }
    },
    methods: {
      get,
      responses(type) {
        return filter(responses.clients, client =>
            client.id === this.client.id && client['type_(client/bank/others)'] === type && client['short_response_(visible)'])
      }
    },
    mounted () {
      document.getElementById('app__container').scrollTop = 0
    }
  }
</script>

<style lang="scss" scoped>
  .client__responses {
    letter-spacing: 1px;
    padding: 19px 0;

    &__tabs {
      &__tab.active {
        box-shadow: 0 -0.3px 0 0 var(--saddle-red) inset, 0 3px 0 0 var(--saddle-red);
      }
    }

    .collapsed > .when-open,
    .not-collapsed > .when-closed {
      display: none;
    }

    &__title {
      background-color: #808080;
      font-weight: 900;
      letter-spacing: 1.5px;
    }

    &__text {
      border: 1px solid black;
      border-bottom-width: 0;

      &:last-child {
        border-bottom-width: 1px;
      }

      &__small {
        font-size: small;
      }
    }

    &__content {
      letter-spacing: 1.2px;
      line-height: 25px;

      mark {
        background-color: #FFEF00;
      }
    }
  }

  @media (min-width: 768px) {
    .client__responses {
      &__tabs {
        justify-content: right;
      }

      &__text {
        border-right: none;
        border-bottom-width: 1px;

        &:first-child {
          border-left: none;
        }
      }
    }
  }
</style>
